<template>
  <div class="history">
    <div class="container">
      <h1 class="header-title">รายการที่คุณบริจาค</h1>
      <ul class="breadcrumb">
        <li class="link"><router-link to="/">หน้าแรก</router-link></li>
        <li class="link">รายการที่คุณบริจาค</li>
      </ul>

      <div class="container block-primary block shadow radius empty-cart mt-30 mb-20" v-if="loading">
        กำลังดึงข้อมูล...
      </div>

      <div class="container block-primary block shadow radius empty-cart mt-30 mb-20" v-if="!loading && loadError">
        มีบางอย่างผิดพลาด <button class="btn btn--purple btn--inline" @click.prevent="delayFetch">ลองใหม่อีกครัง</button>
      </div>

      <div class="order__list block-primary shadow border _clearfix" v-for="order in orders" v-if="!loading && !loadError && orders">
        <div class="history__item">
          <!-- item -->
            <div class="order__list--left col-sm-9 pd-0">

              <div class="order__item col-lg-12 col-xs-12 pd-0">
                <div class="col-lg-3 col-sm-3 col-xs-12 mb-20 pd-0 order__item--date">
                  <div class="history__item--title">วันที่บริจาค</div>
                  <div class="history__item--detail">{{ order.created | date }}</div>
                </div>
                <div class="col-lg-5 col-sm-6 col-xs-12 mb-20 pd-0 order__item--id">
                  <div class="history__item--title">เลขที่บริจาค</div>
                  <div class="history__item--detail">#{{ order.order_id }}</div>
                </div>
                <div class="col-lg-4 col-sm-3 col-xs-12 mb-20 pd-0 order__item--total">
                  <div class="history__item--title">ยอดรวม</div>
                  <div class="history__item--summary">{{ order.total_price | comma }} ฿</div>
                </div>
              </div>

              <div class="product__list col-sm-12 block-third" v-for="product in order.invoice_product_list">
                <div class="col-xs-3 col-sm-2 pd-0">
                  <div class="product__list--image">
                    <img class="img-responsive" :src="productFirstImage(product)" alt="product" />
                  </div>
                </div>
                <div class="col-xs-9">
                  <div class="product__block">
                    <div class="product__title">
                      <router-link :to="{ name: 'product_detail', params: { sku: product.product_sku }}">
                        {{ product.product_name }}
                        <span v-if="product.catalog_sku">({{ product.catalog_name }})</span>
                      </router-link>
                      <span class="text-muted">{{ (product.product_sub_sku || '').replace(/_/g, ' / ') }}</span>
                    </div>
                    <span class="small">x  {{ product.product_quantity }} รายการ </span>
                  </div>
                </div>
              </div>
              <ul class="block--item show-sm">
                <li class="fl-left"><router-link :to="`/orders/${order.order_id}`">ดูรายละเอียดการบริจาค</router-link></li>
                <li class="fl-right hide"><a href="#" @click.prevent="mock()">ยกเลิกรายการ</a></li>
              </ul>

            </div>

          <div class="order__list--right">
            <div class="col-sm-3">
              <div class="col-xs-12 pd-0">
                <order-status :order="order"></order-status>
                <router-link :to="{ name: 'upload-slip', params: { orderId: order.order_id } }" href="#" class="btn btn--purple"
                             v-if="isBankTransfer(order) && !isPaid(order) && !isBankTransferExpired(order)">ส่งหลักฐานการโอนเงิน</router-link>

                <ul class="block--item hide-sm">
                  <li><router-link :to="`/orders/${order.order_id}`">ดูรายละเอียดการบริจาค</router-link></li>
                  <li class="hide"><a href="#" @click.prevent="mock()">ยกเลิกรายการ</a></li>
                </ul>
              </div>
            </div>
          </div>
          <!-- End of history__item -->
        </div>
      </div>

      <div class="container block-primary block shadow radius empty-cart" v-if="!loading && !loadError && (!orders || !orders.length)">
        ยังไม่มีประวัติการบริจาค
        <router-link :to="{ name: 'products_list' }">ไปยังหน้าโครงการ</router-link> เพื่อเริ่มบริจาค
      </div>

    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import OrderStatus from './OrderStatus.vue'

  export default {
    components: {OrderStatus},
    name: 'OrderList',
    data () {
      return {
        orders: [],
        loading: true,
        loadError: false
      }
    },
    mounted () {
      this.fetch()
    },
    computed: {
      legacyUrl () {
        return Vue.config.LEGACY_ORDER_LIST_LINK
      }
    },
    methods: {
      fetch () {
        this.$http.get('invoices?statuses=0,1,2,3&substatuses=0,4,5')
          .then(resp => {
            this.loading = false
            this.loadError = false
            this.orders = resp.body.invoices
            if (this.orders) {
              this.orders = this.orders.filter(item => item.status !== 3 || this.isBankTransferExpired(item))
            }
          })
          .catch(err => {
            console.log(err)
            this.loading = false
            this.loadError = true
          })
      },
      delayFetch () {
        this.loading = true
        setTimeout(() => {
          this.fetch()
        }, 1000)
      },
      catalogName (product) {
        const catalog = this.$store.state.products[product.catalogSku]
        return (catalog && catalog.name) || ''
      },
      productFirstImage (product) {
        product.sku = product.product_sku
        return this.$utils.processProductImages(product)[0].preview
      },
      isBankTransfer (order) {
        return order.payment_method === 'bank_transfer'
      },
      isBankTransferExpired (order) {
        return this.isBankTransfer(order) && order.status === 3 && order.substatus === 5
      },
      isPaid (order) {
        return order.status === 2
      },
      mock () {
        this.$modal.show({
          title: 'ขออภัย',
          text: 'ยังไม่เสร็จครับ'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OrderList.vue?f2785378